
import { Component, Vue } from "vue-property-decorator";

import FinderVue from "@/finder/Finder.vue";

import { IPrj } from "@/prj/IPrj";

import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { PreflightParams } from "../types/IPreflightParams";
import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";
import { Uploader } from "@/uploader/Uploader";

import { lbl_api } from "@/lbl/ILblSvc";
import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { IUser } from "@/../../server/src/user/IUser";
import { Finder } from "@/finder/IFinder";
import { DateString } from "@/DateString";
import TasksVue from  "@/task/Tasks.vue";
import { ITaskParent } from "server/src/task/ITaskParent";
import { IGroup } from "@/groups/IGroup";
import ClipMulti from "@/clip/ClipMulti";
import  ClipUseMultiVue from "@/clip/ClipUseMulti.vue";
// import { MqttClient} from "./MqttClient"
// const mc = new MqttClient()
// mc.connect();


@Component({ components: { FinderVue, ButtonVue, UploaderVue, TasksVue, ClipUseMultiVue } })
export default class PrjVue extends Vue {
  id:string="";
  _id:string="";
  prj: IPrj|undefined=undefined;
  key=0;
  new_labels=0;
  users:IUser[]=[]
  customers:any[]=[]
  customer_contacts:any[]=[]
  task_parent: ITaskParent | undefined;
  grupy_key=0
  
  
  uploader_autorefresh:boolean = false;
  uploader_callback:Uploader = new Uploader()
  
  preflight_params: PreflightParams = {

    parent_id: "",
    version: 1,
    modified_by: "",
    date_created: "",
    date_modified: "",
    type:"lbl",

    klient: "",
    klient_obj:{} ,
    handlowiec_obj:{},

    klient_index_id: "",

    projekt_idn: "",
    tagi: "",
    uwagi: "",
    handlowiec: "",

    preflighter: "",
    kto_projektowal:"",
    kto_preflightowal:"",
    kto_przygotowal_do_druku:"",
    original_file_name: "",
    groups: []
  };


  async mounted() {
    console.log('mounted',this.$route.params.prj_id)
    this._id=this.$route.params.prj_id  
    this.uploader_callback.files_changed_cb = this.files_dropped
    await this.refresh()
  }

  debug: boolean = false;
  created() {
    bus.register("handlowiec_selected", this.handlowiec_selected);
    bus.register("klient_selected", this.klient_selected);
    bus.register("klient_kontakt_selected", this.klient_kontakt_selected);
  }

  beforeDestroy() {
    bus.remove("handlowiec_selected", this.handlowiec_selected);
    bus.remove("klient_selected", this.klient_selected);
    bus.remove("klient_kontakt_selected", this.klient_selected);
  }

  async chg() {
    if (!this.prj) return;

    try {
      this.prj.version++;
      console.log("projekt:"+this.prj.idn+" "+this.prj.klient?.text+" "+this.prj.handlowiec?.text)
      const p:any=await bus.call('/api/projekt/update', this.prj)
      if (p && p._id) { 
        //alert("Zapisano projekt:"+p.idn+" "+p.klient?.text+" "+p.handlowiec?.text)
        this.prj=p;
      } else {
        alert("Problem z zapisem danych projektu")
      }
    } catch (err) {
      //this.prj.version--;
      console.log(err)
    }
  }

  async files_dropped(files:string[]) {
    console.log("************* files_dropped",files)
    if (files.length==0) this.uploader_autorefresh = false;
  }

  set_preflight_params() {
    if (!this.prj) return;
    this.preflight_params.parent_id = this.prj._id;
    this.preflight_params.tagi = this.prj.tagi;
    this.preflight_params.uwagi = this.prj.uwagi;
    this.preflight_params.projekt_idn = this.prj.idn;
    this.preflight_params.handlowiec = this.prj.handlowiec.text;
    this.preflight_params.handlowiec_obj = this.prj.handlowiec;
    this.preflight_params.klient = this.prj.klient.text;
    this.preflight_params.klient_obj = this.prj.klient;

    this.preflight_params.klient_index_id = this.prj.klient.data.data_nr_klienta;
    this.preflight_params.version = 1;
    this.preflight_params.date_created = DateString.toISOString()
    this.preflight_params.date_modified = DateString.toISOString()
    this.preflight_params.modified_by = "";
    this.preflight_params.groups=this.prj.groups?this.prj.groups:[]
  }

  async del(prj: IPrj) {
    try {
      prj = await bus.call("/api/projekt/del", prj)
      //this.prj=undefined;
    } catch (err) {
      alert("Projekt skasowano")
    }
    
  }

  async handlowiec_selected(e: any) {
    console.log("Prj.handlowiec_selected",JSON.stringify(e.detail))
    if (this.prj)  this.prj.handlowiec = e.detail
    await this.chg();
  }
  
  async klient_selected(e: any) {
    console.log("Prj.klient_selected",JSON.stringify(e.detail))
    if (this.prj)  this.prj.klient = e.detail
    if (this.prj) {
      console.log("Klient",JSON.stringify(this.prj.klient))
      if (this.prj.klient.text) {
        this.customer_contacts = await bus.call("/api/cust/get_customer_contacts",{odbiorca_idn:this.prj.klient.text});
      }
    }
    await this.chg();
  }

  async klient_kontakt_selected(e: any) {
    if (this.prj) {
      console.log("Klient kontakt",JSON.stringify(this.prj.klient_kontakt))
    }
    await this.chg();
  }


  async preflight() {

    this.set_preflight_params();
    if (!this.preflight_params.klient) {
      alert("Najpierw przypisz klienta do projektu")
      return;
    }
    if (!this.preflight_params.handlowiec) {
      alert("Najpierw przypisz handlowca do projektu")
      return;
    }

    
    console.log(this.preflight_params)
    
    const files = await bus.call(lbl_api.start_flow_preflight,{preflight_params:this.preflight_params});
    if (files && files.length)  {
      alert("Przekazano pliki do cloudflow") 
      this.uploader_autorefresh=true;
    }
  }
 

  async etykiety_projektu(prj_id:string, prj_idn:string) {
    //const prj_str = JSON.stringify({_id: prj_id, idn: prj_idn})
    window.router.push({ path: "/projekty/"+prj_id+"/etykiety"}) 
  }

  async technologie_projektu(prj_id:string, prj_idn:string) {
    //const prj_str = JSON.stringify({_id: prj_id, idn: prj_idn})
    window.router.push({ path: "/projekty/"+prj_id+"/technologie"}) 
  }
    
  to_clipboard(prj:IPrj) {
    let str=""
    if (!prj) return "";
    if (!prj._id) return "";


    const obj={projekt: { id: prj._id, idn:prj.idn }}

    str='Projekt: '+window.location.href+'\r\n #'+JSON.stringify(obj)+'#'
    navigator.clipboard.writeText(str)
    alert("Skopiowano dane projektu do notatnika. Wejdź do maila i naciśnij Ctrl+V")
    return str;
  }


  async refresh() {

    const masterData: MasterData|undefined =  await (await new Store().getStore()).masterData;

    if (!masterData) return;
    this.users         = masterData.users
    this.customers     = masterData.customers


    console.log("refresh id", this._id)
    const p = await bus.call("/api/projekt/find_by_id", { _id: this._id } )
    if (p) {
      // this.prj = await Prj.create("root") //prj_has_no_parent
      this.prj=p;
      if (!p.klient_kontakt) p.klient_kontakt = new Finder();
      if (this.prj && this.prj.klient && this.prj.klient.text) {
        this.customer_contacts = await bus.call("/api/cust/get_customer_contacts",{odbiorca_idn:this.prj.klient.text});
        console.log(this.customer_contacts)
      }

      this.id=this._id;
      this.task_parent = { prj_id: this._id, prj_url: "", lbl_url:"" } 
      this.key++;
    }
  }

  async reset_emails(groups:IGroup[],i:number) {
    
    if (this.prj) {
      this.prj.groups=[]
      const clip = new ClipMulti().getClip()
      clip.reset("groups")
    }
    this.grupy_key++
  }

    async use_groups_from_clipboard(groups: IGroup[]) {
      
      if (!this.prj) return;
      this.prj.groups=groups
      //new EmailExtractor().use_groups_from_clipboard(groups, this.lbl)
      await this.chg();
  }


}
